module.exports = __webpack_public_path__ + "img/chevrolet_thumbnail.a3b0c132.png";